<div class="revamped-sidebar">
  <!-- Top Section with unified background #FBFBFB -->
  <div class="top-section">
    <!-- Back Button (shown when navigating from talent pool) -->
    <button *ngIf="showBackButton" class="back-button-header" (click)="backClicked.emit()"
      title="Back to Event Details">
      <i class="pi pi-arrow-left"></i>
    </button>

    <!-- Header Banner with Gradient Background (reduced height) -->
    <div class="header-banner gradient-banner"></div>

    <!-- Profile Avatar - Positioned to overlap header -->
    <div class="profile-avatar-container">
      <div class="profile-avatar-large" [style.background-color]="getAvatarColor(getFullName())">
        <img *ngIf="hasValidPhoto(selectedUser)" [src]="selectedUser.photo" [alt]="getFullName()" class="avatar-image"
          (error)="onImageError($event, selectedUser)" (load)="onImageLoad($event)" />
        <span class="avatar-initials" [style.display]="hasValidPhoto(selectedUser) ? 'none' : 'flex'">
          {{ getInitials(getFullName()) }}
        </span>
      </div>
    </div>

    <!-- Profile Info Section - Name, Email, Short ID -->
    <div class="profile-info-section">
      <div class="name-with-badge">
        <h2 class="candidate-name-large">{{selectedUser.name}}</h2>
        <span *ngIf="!disableStage" class="stage-badge-inline">
          {{ selectedUser?.stage?.current_stage || 0 }}/{{ selectedUser?.stage?.total_stage || 1 }}
        </span>
      </div>
      <div class="candidate-meta-row">
        <span class="candidate-email copyable-text" (click)="copyToClipboard(selectedUser?.email, 'Email')"
          title="Click to copy">
          <i class="pi pi-envelope"></i>
          {{selectedUser?.email || '-'}}
        </span>
        <span class="meta-separator">•</span>
        <span class="candidate-short-id copyable-text" (click)="copyToClipboard(selectedUser?.id, 'ID')"
          title="Click to copy">
          <i class="pi pi-copy"></i>
          {{selectedUser?.id?.slice(-12) || '-'}}
        </span>
      </div>
    </div>

    <!-- Tab Navigation - Pill Style -->
    <div class="new-tab-nav">
      <button class="new-tab" [class.active]="displayInfo" (click)="showInfo()">
        <i class="pi pi-user"></i>
        <span>Personal</span>
      </button>
      <button class="new-tab" [class.active]="displayInsights" (click)="showInsights()">
        <i class="pi pi-bolt"></i>
        <span>Insights</span>
      </button>
      <button *ngIf="!disableFeedback" class="new-tab" [class.active]="displayFeedback" (click)="showFeedback()">
        <i class="pi pi-copy"></i>
        <span>Documents & Feedback</span>
      </button>
      <button *ngIf="userPrivileges.has('event_candidate_activities.view') && !disableActivity" class="new-tab" [class.active]="displayActivity" (click)="showActivity()">
        <i class="pi pi-wave-pulse"></i>
        <span>Activity</span>
      </button>
    </div>
  </div>

  <!-- Content Section with background #FCFBFF - Only for Personal and Insights tabs -->
  <div class="content-section" *ngIf="displayInfo || displayInsights">
    <!-- Personal Tab Content -->
    <div class="personal-tab-content" *ngIf="displayInfo">

      <!-- Primary Details Section -->
      <div class="details-section-card">
        <h3 class="section-title-new">Primary Details</h3>
        <div class="primary-details-grid">
          <div class="primary-detail-item">
            <div class="detail-icon-wrapper">
              <i class="pi pi-mars detail-svg-icon"></i>
            </div>
            <div class="detail-text-content">
              <span class="detail-label-new">GENDER</span>
              <span class="detail-value-new">{{ getPersonalInfoValue('Gender') }}</span>
            </div>
          </div>
          <div class="primary-detail-item">
            <div class="detail-icon-wrapper">
              <i class="pi pi-calendar detail-svg-icon"></i>
            </div>
            <div class="detail-text-content">
              <span class="detail-label-new">DATE OF BIRTH</span>
              <span class="detail-value-new">{{ getPersonalInfoValue('Date of Birth') }}</span>
            </div>
          </div>
        </div>
        <div class="primary-details-grid single">
          <div class="primary-detail-item full-width">
            <div class="detail-icon-wrapper">
              <i class="pi pi-map-marker detail-svg-icon"></i>
            </div>
            <div class="detail-text-content">
              <span class="detail-label-new">ADDRESS</span>
              <span class="detail-value-new">{{ getPersonalInfoValue('Address') || getPersonalInfoValue('Current Address') || getPersonalInfoValue('City') || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="details-section-card" *ngIf="pdfSrc || isLoadingResume">
        <h3 class="section-title-new">Resume</h3>
        <div class="resume-link-wrapper" *ngIf="!isLoadingResume">
          <div class="resume-file-link" *ngIf="pdfSrc" (click)="openResumeInNewTab()">
            <div class="resume-pdf-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="pdf-svg">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <text x="8" y="16" font-size="6" fill="currentColor" stroke="none">{{ resumeFileType === 'docx' || resumeFileType === 'doc' ? 'DOC' : 'PDF' }}</text>
              </svg>
            </div>
            <span class="resume-file-text">{{selectedUser.name}} Resume.{{ resumeFileType === 'docx' || resumeFileType === 'doc' ? 'DOCX' : 'PDF' }}</span>
          </div>
        </div>
        <div class="resume-loading" *ngIf="isLoadingResume">
          <i class="pi pi-spin pi-spinner"></i>
          <span>Loading resume...</span>
        </div>
      </div>
      <!-- Contact Details Section -->
      <div class="details-section-card">
        <h3 class="section-title-new">Contact Details</h3>
        <div class="contact-details-grid">
          <div class="contact-detail-item">
            <div class="detail-icon-wrapper contact-icon">
              <i class="pi pi-envelope"></i>
            </div>
            <div class="detail-text-content">
              <span class="detail-label-new">EMAIL</span>
              <span class="detail-value-email" (click)="copyToClipboard(selectedUser?.email, 'Email')"
                [title]="'Click to copy: ' + selectedUser?.email">
                {{selectedUser?.email}}
              </span>
            </div>
          </div>
          <div class="contact-detail-item">
            <div class="detail-icon-wrapper contact-icon">
              <i class="pi pi-mobile"></i>
            </div>
            <div class="detail-text-content">
              <span class="detail-label-new">PHONE</span>
              <span class="detail-value-phone" (click)="copyToClipboard(selectedUser?.mobile_number, 'Phone')"
                [title]="'Click to copy: ' + selectedUser?.mobile_number">
                {{selectedUser?.mobile_number || '-'}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Educational Details Section -->
      <div class="details-section-card">
        <h3 class="section-title-new">Educational Details</h3>

        <!-- UG Education Card -->
        <div class="edu-card-wrapper" *ngIf="hasUGDetails">
          <div class="edu-type-badge">UG</div>
          <div class="edu-fields-container">
            <div class="edu-row">
              <div class="edu-field-box wide">
                <span class="edu-field-label">DEGREE</span>
                <span class="edu-field-value">{{ getUGFieldValue('Degree') || '-' }}</span>
              </div>
              <div class="edu-field-box wide">
                <span class="edu-field-label">SPECIALIZATION</span>
                <span class="edu-field-value">{{ getUGFieldValue('Specialization') || '-' }}</span>
              </div>
              <div class="edu-field-box">
                <span class="edu-field-label">PERCENTAGE</span>
                <span class="edu-field-value">{{ getUGFieldValue('Percentage') || getUGFieldValue('CGPA') || '-'
                  }}</span>
              </div>
            </div>
            <div class="edu-row">
              <div class="edu-field-box small">
                <span class="edu-field-label">BATCH</span>
                <span class="edu-field-value">{{ getUGFieldValue('Batch') || getUGFieldValue('Year of Passing') || '-'
                  }}</span>
              </div>
              <div class="edu-field-box wide">
                <span class="edu-field-label">COLLEGE</span>
                <span class="edu-field-value">{{ getUGFieldValue('College') || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- PG Education Card -->
        <div class="edu-card-wrapper" *ngIf="hasPGDetails">
          <div class="edu-type-badge">PG</div>
          <div class="edu-fields-container">
            <div class="edu-row">
              <div class="edu-field-box wide">
                <span class="edu-field-label">DEGREE</span>
                <span class="edu-field-value">{{ getPGFieldValue('Degree') || '-' }}</span>
              </div>
              <div class="edu-field-box wide">
                <span class="edu-field-label">SPECIALIZATION</span>
                <span class="edu-field-value">{{ getPGFieldValue('Specialization') || '-' }}</span>
              </div>
              <div class="edu-field-box">
                <span class="edu-field-label">PERCENTAGE</span>
                <span class="edu-field-value">{{ getPGFieldValue('Percentage') || getPGFieldValue('CGPA') || '-'
                  }}</span>
              </div>
            </div>
            <div class="edu-row">
              <div class="edu-field-box small">
                <span class="edu-field-label">BATCH</span>
                <span class="edu-field-value">{{ getPGFieldValue('Batch') || getPGFieldValue('Year of Passing') || '-'
                  }}</span>
              </div>
              <div class="edu-field-box wide">
                <span class="edu-field-label">COLLEGE</span>
                <span class="edu-field-value">{{ getPGFieldValue('College') || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Diploma Education Card -->
        <div class="edu-card-wrapper" *ngIf="hasDiplomaDetails">
          <div class="edu-type-badge">Diploma</div>
          <div class="edu-fields-container">
            <div class="edu-row">
              <div class="edu-field-box wide">
                <span class="edu-field-label">DEGREE</span>
                <span class="edu-field-value">{{ getDiplomaFieldValue('Degree') || '-' }}</span>
              </div>
              <div class="edu-field-box wide">
                <span class="edu-field-label">SPECIALIZATION</span>
                <span class="edu-field-value">{{ getDiplomaFieldValue('Specialization') || '-' }}</span>
              </div>
              <div class="edu-field-box">
                <span class="edu-field-label">PERCENTAGE</span>
                <span class="edu-field-value">{{ getDiplomaFieldValue('Percentage') || getDiplomaFieldValue('CGPA') ||
                  '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- No Education Message -->
        <div class="no-education-msg" *ngIf="!hasAnyEducationalQualifications()">
          <i class="pi pi-info-circle"></i>
          <span>No educational qualifications found</span>
        </div>
      </div>


    </div>

    <!-- Insights Tab Content (Hidden but kept for functionality) -->
    <div style="overflow-y: scroll;" class="{{displayInsights ? 'userInfo-content' : 'hidden'}} section">

      <!-- Loading State -->
      <div *ngIf="isLoadingDetails" class="insights-loading-container">
        <div class="loading-spinner-container">
          <div class="spinner"></div>
        </div>
        <p class="loading-text">Loading candidate insights...</p>
      </div>

      <!-- Content when data is available -->
      <div *ngIf="!isLoadingDetails && isSkillScoreEnabled() && roleScores && roleScores.length > 0"
        class="insights-cards">
        <div class="insights-top-header">
          <i class="pi pi-check-circle insights-top-icon"></i>
          <span class="insights-top-title">Agent Smith Insights</span>
        </div>
        <div class="insights-card" *ngFor="let roleScore of roleScores; let idx = index">
          <div class="insights-card-header">
            <div class="header-left">
              <div class="header-text">
                <div class="role-name">{{ roleScore.role_name }}</div>
              </div>
            </div>
            <div class="header-right">
              <div class="alignment-score-group">
                <span class="alignment-badge small" [ngClass]="getAlignmentClass(roleScore.alignment_category)">
                  {{ roleScore.alignment_category }}
                </span>
                <span class="score-text-small">{{ roleScore.overall_role_score }}/100</span>
              </div>
            </div>
          </div>

          <div class="insights-strengths" *ngIf="roleScore.strengths && roleScore.strengths.length > 0">
            <div class="strengths-title-small">Key Strengths</div>
            <div class="strength-item-line" *ngFor="let strength of roleScore.strengths; let sIdx = index">
              <div class="strength-number">{{ sIdx + 1 }}</div>
              <div class="strength-content">{{ strength }}</div>
            </div>
          </div>

          <div class="no-strengths" *ngIf="!roleScore.strengths || roleScore.strengths.length === 0">
            <p class="no-strengths-text">No strengths identified for this role</p>
          </div>
        </div>
      </div>

      <!-- No Analysis Found when skill scores enabled but no data -->
      <div *ngIf="!isLoadingDetails && isSkillScoreEnabled() && (!roleScores || roleScores.length === 0)"
        class="no-analysis-container">
        <div class="no-analysis-content">
          <div class="no-analysis-icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <h3 class="no-analysis-title">No Analysis Found</h3>
          <p class="no-analysis-description">
            No analysis available for this candidate at this time.
          </p>
        </div>
      </div>

      <!-- Premium/Pro Version UI when skill scores disabled -->
      <div *ngIf="!isLoadingDetails && !isSkillScoreEnabled()" class="premium-insights-container">
        <div class="premium-content">
          <div class="premium-image-container">
            <img src="assets/Copilot insights.png" alt="Copilot Insights" class="premium-image">
          </div>

          <span class="pro-version-text">
            Agent Smith Insights is a Pro Version <br>Contact Support Team to enable this feature.
          </span>
        </div>
      </div>
    </div>

    <div class="resume-container" *ngIf="displayResume">
      <p *ngIf="isLoadingResume">Loading Resume...</p>

      <ng-container *ngIf="!isLoadingResume && !pdfSrc; else showResume">
        <div class="no-resume-container">
          <div class="no-resume-icon-container">
            <i class="pi pi-file-o"></i>
          </div>
          <p class="no-resume-title">No Resume Available</p>
        </div>
      </ng-container>

      <ng-template #showResume>
        <div *ngIf="pdfSrc">
          <iframe *ngIf="resumeFileType === 'pdf'" [src]="sanitizer.bypassSecurityTrustResourceUrl(pdfSrc!)" width="100%" height="600px"
            allow="fullscreen"></iframe>
          <iframe *ngIf="resumeFileType === 'docx' || resumeFileType === 'doc'" 
            [src]="sanitizer.bypassSecurityTrustResourceUrl(getResumeViewerUrl(pdfSrc!))" 
            width="100%" height="600px" allow="fullscreen"></iframe>
        </div>
      </ng-template>

    </div>
  </div>

  <div class="tab-content-no-bg" *ngIf="displayFeedback">
    <!-- Loading State -->
    <div *ngIf="isLoadingFeedback" class="feedback-loading-container">
      <div class="loading-spinner-container">
        <div class="spinner"></div>
      </div>
    </div>

      <!-- Main Content -->
      <div *ngIf="!isLoadingFeedback" class="docs-feedback-main">

        <!-- Registration Details Section -->
        <div class="df-section">
          <h3 class="df-section-title">Registration Details</h3>

          <!-- Registration Forms Cards -->
          <div *ngIf="registrationForms.length > 0" class="df-cards-container">
            <div *ngFor="let form of registrationForms; let i = index" class="df-form-card">
              <div class="df-form-header">
                <div class="df-form-icon">
                  <i class="pi pi-file-edit"></i>
                </div>
                <div class="df-form-info">
                  <h4 class="df-form-name">Form {{ i + 1 }}</h4>
                  <p class="df-form-date">Submitted on {{ form.submittedDate | date: 'dd MMM yy' }}</p>
                </div>
              </div>
              <div class="df-form-actions">
                <button class="df-action-btn view" (click)="viewRegistrationByIndex(i)">
                  View Details
                </button>
                <button class="df-action-btn download" (click)="downloadRegistrationDetailsByIndex(i)">
                  Download Details
                </button>
                <button class="df-action-btn attachments" *ngIf="userPrivileges.has('event_candidate_form_documents.download')" (click)="downloadAttachmentsByIndex('registration', i)">
                  Download Attachments
                </button>
              </div>
            </div>
          </div>

          <!-- No Registration Data -->
          <div *ngIf="registrationForms.length === 0" class="df-empty-state">
            <div class="df-empty-icon">
              <i class="pi pi-file-edit"></i>
            </div>
            <span class="df-empty-text">No Registration Forms Available</span>
          </div>
        </div>

        <!-- Document Details Section -->
        <div class="df-section">
          <h3 class="df-section-title">Document Details</h3>

          <!-- Documentation Cards -->
          <div *ngIf="documentationForms.length > 0" class="df-cards-container">
            <div *ngFor="let form of documentationForms; let i = index" class="df-form-card">
              <div class="df-form-header">
                <div class="df-form-icon">
                  <i class="pi pi-file-pdf"></i>
                </div>
                <div class="df-form-info">
                  <h4 class="df-form-name">{{ form.stageName || 'Document ' + (i + 1) }}</h4>
                  <p class="df-form-date">Submitted on {{ form.submittedDate | date: 'dd MMM yy' }}</p>
                </div>
              </div>
              <div class="df-form-actions">
                <button class="df-action-btn view" (click)="viewDocumentationByIndex(i)">
                  View Details
                </button>
                <button class="df-action-btn download" (click)="downloadDocumentationDetailsByIndex(i)">
                  Download Details
                </button>
                <button class="df-action-btn attachments" *ngIf="userPrivileges.has('event_candidate_form_documents.download')" (click)="downloadAttachmentsByIndex('documentation', i)">
                  Download Attachments
                </button>
              </div>
            </div>
          </div>

          <!-- No Documents Data -->
          <div *ngIf="documentationForms.length === 0" class="df-empty-state">
            <div class="df-empty-icon">
              <i class="pi pi-file-o"></i>
            </div>
            <span class="df-empty-text">No Documents Available</span>
          </div>
        </div>

        <!-- Feedback Details Section -->
        <div class="df-section">
          <h3 class="df-section-title">Feedback Details</h3>

        <!-- Feedback Cards -->
        <div *ngIf="groupedFeedbackForms.length > 0" class="df-cards-container">
          <div *ngFor="let group of groupedFeedbackForms; let i = index" class="df-form-card">
            <div class="df-form-header">
              <div class="df-form-icon">
                <i class="pi pi-comments"></i>
              </div>
              <div class="df-form-info">
                <h4 class="df-form-name">{{ group.stageName || 'Feedback ' + (i + 1) }}
                  <span *ngIf="group.panelMembers" class="panel-count-badge">
                    {{ group.panelMembers.length }} Panel Members
                  </span>
                </h4>
                <p class="df-form-date">Submitted on {{ group.submittedDate | date: 'dd MMM yy' }}</p>
              </div>
            </div>
            <div class="df-form-actions">
              <button class="df-action-btn view" (click)="viewGroupedFeedbackByIndex(i)">
                View Details
              </button>
              <button *ngIf="!group.panelMembers" class="df-action-btn download"
                (click)="downloadFeedbackDetailsByIndex(i)">
                Download Details
              </button>
            </div>
          </div>
        </div>

          <!-- No Feedback Data -->
        <div *ngIf="groupedFeedbackForms.length === 0" class="df-empty-state">
            <div class="df-empty-icon">
              <i class="pi pi-comments"></i>
            </div>
            <span class="df-empty-text">No Feedback Available</span>
          </div>
        </div>

        <!-- Test Details Section -->
        <div class="df-section">
          <h3 class="df-section-title">Test Details</h3>

          <div *ngIf="testDetailsList.length > 0" class="df-cards-container">
            <div *ngFor="let test of testDetailsList; let i = index" class="df-form-card">
              <div class="df-form-header">
                <div class="df-form-icon">
                  <i class="pi pi-code"></i>
                </div>
                <div class="df-form-info">
                  <h4 class="df-form-name">{{ test.contest_test_name || 'Test ' + (i + 1) }}</h4>
                  <p class="df-form-date">Submitted on {{ test.submittedDate !== '-' ? (test.submittedDate | date: 'dd MMM yy') : '-' }}</p>
                </div>
              </div>
              <div class="df-form-actions">
                <button class="df-action-btn view" (click)="viewTestDetailsByIndex(i)">
                  View Details
                </button>
                <button class="df-action-btn download" (click)="downloadTestDetailsByIndex(i)">
                  Download Details
                </button>
              </div>
            </div>
          </div>

          <!-- No Test Data -->
          <div *ngIf="testDetailsList.length === 0" class="df-empty-state">
            <div class="df-empty-icon">
              <i class="pi pi-code"></i>
            </div>
            <span class="df-empty-text">No Test Details Available</span>
          </div>
        </div>

      </div>
    </div>

  <div class="tab-content-no-bg" *ngIf="displayActivity">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="activity-loading-new">
      <div class="loading-spinner-container">
        <div class="spinner"></div>
      </div>
    </div>

    <!-- No Activity State -->
    <div *ngIf="!isLoading && timelyActivity.length === 0" class="activity-empty-state">
      <div class="activity-empty-icon">
        <i class="pi pi-history"></i>
      </div>
      <span class="activity-empty-text">No Activity Available</span>
    </div>

      <!-- Activity Cards -->
      <div class="activity-cards-container" *ngIf="timelyActivity.length">
        <ng-container *ngFor="let dateGroup of timelyActivity">
          <ng-container *ngFor="let activity of dateGroup">
            <div class="activity-card-new">
              <!-- Card Header -->
              <div class="activity-card-header">
                <div class="activity-header-left">
                  <div class="activity-type-icon">
                    <i class="pi pi-arrow-right-arrow-left"></i>
                  </div>
                  <div class="activity-header-info">
                    <h4 class="activity-type-title">{{ getActivityTitle(activity.action) }}</h4>
                    <span class="activity-author-text">BY {{ (activity.createdBy || 'Hire Automation') | uppercase
                      }}</span>
                  </div>
                </div>
                <div class="activity-header-right">
                  <div class="activity-datetime">
                    <span class="activity-date">{{ activity.movedDate | date:'dd MMM yy' }}</span>
                    <span class="activity-time-divider">|</span>
                    <span class="activity-time-new">{{ activity.movedOn | date:'hh:mm a' }}</span>
                  </div>
                </div>
              </div>

              <!-- Stage Change Row -->
              <div class="stage-change-row" *ngIf="activity.oldStage !== '-' && activity.newStage !== '-'">
                <div class="stage-badge-from">{{ activity.oldStage | uppercase }}</div>
                <div class="stage-arrow-line">
                  <svg width="240" height="24" viewBox="0 0 240 24">
                    <defs>
                      <marker
                        id="arrowhead"
                        markerWidth="6"
                        markerHeight="6"
                        refX="6"
                        refY="3"
                        orient="auto">
                        <polygon points="0 0, 6 3, 0 6" fill="#6B6B8C" />
                      </marker>
                    </defs>
                  
                    <line
                      x1="5"
                      y1="12"
                      x2="225"
                      y2="12"
                      stroke="#6B6B8C"
                      stroke-width="1.5"
                      stroke-dasharray="3,3"
                      marker-end="url(#arrowhead)"
                    />
                  </svg>
                  
                </div>
                <div class="stage-badge-to">{{ activity.newStage | uppercase }}</div>
              </div>

              <!-- Email Subject (for Send Mail action) -->
              <div class="activity-email-section" *ngIf="activity.action === 'Send Mail'">
                <div class="email-subject-text">
                  <i class="pi pi-envelope"></i>
                  <span>Email Sent Successfully</span>
                </div>
              </div>

            <!-- Remarks Section -->
            <div class="activity-remarks-section"
              *ngIf="activity.remarks && activity.remarks.trim() !== '' && activity.remarks.trim() !== '-'">
              <h5 class="remarks-title">Remarks</h5>
              <ul class="remarks-list">
                <li>{{ activity.remarks }}</li>
              </ul>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
<!-- Registration Details Dialog -->
<p-dialog *ngIf="showRegistrationDialog" header="Registration Details" [(visible)]="showRegistrationDialog"
  [modal]="true"[focusTrap]="false"[style]="{width: '75vw', height: '80vh'}" (onHide)="showRegistrationDialog = false" appendTo="body">

  <div *ngIf="isLoadingDetails" class="loading-feedback center-loader">
    <p-progressSpinner strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoadingDetails">
    <div *ngIf="registrationDetails.length > 0; else noData" class="registration-details-container">
      <div *ngFor="let section of detailsGrouped; let last = last">
        <div class="registration-section">
          <div class="registration-section-title">{{ section.name }}</div>
          <hr class="section-underline">
        </div>
        <div *ngFor="let model of section.fields">
          <div class="registration-row" *ngIf="model && !model.isMultiFile && !model.isUrl">
            <div class="registration-field label">{{ model.label }}</div>
            <div class="registration-field separator">:</div>
            <div class="registration-field value"
              [innerHTML]="model.value !== null && model.value !== undefined ? model.value : '-'"></div>
          </div>
          <div class="registration-row" *ngIf="model && model.isUrl">
            <div class="registration-field label">{{ model.label }}</div>
            <div class="registration-field separator">:</div>
            <div class="registration-field value">
              <button class="file-action-btn view-btn" (click)="viewFile(model.url)" title="View file">
                <i class="pi pi-eye"></i>
              </button>
            </div>
          </div>

          <!-- Multi-file display -->
          <div *ngIf="model.isMultiFile && model.fileList && model.fileList.length > 0" class="multi-file-container">
            <div class="multi-file-label">{{ model.label }}</div>
            <div class="file-list">
              <div *ngFor="let file of model.fileList" class="file-item">
                <div class="file-icon-container">
                  <div class="file-icon" [ngClass]="'file-type-' + file.fileType.toLowerCase()">
                    <i class="pi" [ngClass]="getFileIcon(file.fileType)"></i>
                  </div>
                </div>
                <div class="file-details">
                  <div class="file-name">{{ file.fileName }}</div>
                  <div class="file-meta">
                    <span class="file-type-badge">{{ file.fileType }}</span>
                  </div>
                </div>
                <div class="file-actions">
                  <button class="file-action-btn view-btn" (click)="viewFile(file.url)" title="View file">
                    <i class="pi pi-eye"></i>
                  </button>
                  <!-- <button class="file-action-btn download-btn" 
                            (click)="downloadFile(file.url, file.fileName)" 
                            title="Download file">
                      <i class="pi pi-download"></i>
                    </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!last" class="horizontal-line-wrapper">
          <hr class="section-divider" />
        </div>
      </div>
    </div>
    <ng-template #noData>
      <p>No Data Found</p>
    </ng-template>
  </div>
</p-dialog>

<!-- Documentation Details Dialog -->
<p-dialog header="Documentation Details" [(visible)]="showDocumentationDialog" [modal]="true" [focusTrap]="false"
  [style]="{width: '75vw', height: '80vh'}" (onHide)="closeDocumentationDialog()" appendTo="body">


  <div *ngIf="isLoadingDetails" class="loading-feedback center-loader">
    <p-progressSpinner strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoadingDetails">
    <div class="documentation-details-container">
      <div *ngFor="let section of detailsGrouped; let last = last">
        <div class="documentation-section">
          <div class="documentation-section-title">{{ section.name }}</div>
          <hr class="section-underline">
        </div>
        <div *ngFor="let item of section.fields">
          <div class="documentation-row" *ngIf="!item.isMultiFile && !item.isUrl">
            <div class="documentation-field label">{{ item.label }}</div>
            <div class="documentation-field separator">:</div>
            <div class="documentation-field value" [innerHTML]="item.value ? item.value : '-'"></div>
          </div>
          <div class="documentation-row" *ngIf="item.isUrl">
            <div class="documentation-field label">{{ item.label }}</div>
            <div class="documentation-field separator">:</div>
            <div class="documentation-field value">
              <button class="file-action-btn view-btn" (click)="viewFile(item.url)" title="View file">
                <i class="pi pi-eye"></i>
              </button>
            </div>
          </div>

          <!-- Multi-file display -->
          <div *ngIf="item.isMultiFile && item.fileList && item.fileList.length > 0" class="multi-file-container">
            <div class="multi-file-label">{{ item.label }}</div>
            <div class="file-list">
              <div *ngFor="let file of item.fileList" class="file-item">
                <div class="file-icon-container">
                  <div class="file-icon" [ngClass]="'file-type-' + file.fileType.toLowerCase()">
                    <i class="pi" [ngClass]="getFileIcon(file.fileType)"></i>
                  </div>
                </div>
                <div class="file-details">
                  <div class="file-name">{{ file.fileName }}</div>
                  <div class="file-meta">
                    <span class="file-type-badge">{{ file.fileType }}</span>
                  </div>
                </div>
                <div class="file-actions">
                  <button class="file-action-btn view-btn" (click)="viewFile(file.url)" title="View file">
                    <i class="pi pi-eye"></i>
                  </button>
                  <button class="file-action-btn download-btn" (click)="downloadFile(file.url, file.fileName)"
                    title="Download file">
                    <i class="pi pi-download"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!last" class="horizontal-line-wrapper">
          <hr class="section-divider" />
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Feedback Details Dialog -->
<p-dialog header="Feedback Details" [(visible)]="showFeedbackDialog" [modal]="true"
  [style]="{width: '75vw', height: '80vh'}" (onHide)="showFeedbackDialog = false" appendTo="body">

  <div *ngIf="isLoadingDetails" class="loading-feedback center-loader">
    <p-progressSpinner strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoadingDetails" class="feedback-dialog-body">
    <div *ngIf="selectedFeedbackGroupIndex >= 0 && groupedFeedbackForms[selectedFeedbackGroupIndex]?.panelMembers"
      class="feedback-panel-tabs">
      <div *ngFor="let member of groupedFeedbackForms[selectedFeedbackGroupIndex].panelMembers; let mi = index"
        class="feedback-panel-tab" [class.active]="selectedFeedbackPanelIndex === mi"
        (click)="selectFeedbackPanelMember(selectedFeedbackGroupIndex, mi)">
        <i class="pi pi-user"></i>
        <span>{{ member.submittedBy || 'Panel Member ' + (mi + 1) }}</span>
      </div>
    </div>

    <div class="feedback-details-container">
      <div *ngFor="let section of getGroupedSections(feedbackDetailsData); let last = last">
        <div class="feedback-section">
          <div class="feedback-section-title">{{ section.name }}</div>
          <hr class="section-underline">
        </div>
        <div *ngFor="let item of section.fields">
          <div class="feedback-row">
            <div class="feedback-field label">{{ item.label }}</div>
            <div class="feedback-field separator">:</div>
            <div class="feedback-field value" [innerHTML]="item.value ? item.value : '-'"></div>
          </div>
        </div>
        <div *ngIf="!last" class="horizontal-line-wrapper">
          <hr class="section-divider" />
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Test Details Dialog -->
<p-dialog header="Test Details" [(visible)]="showTestDialog" [modal]="true" [style]="{width: '75vw', height: '80vh'}"
  (onHide)="showTestDialog = false" appendTo="body">

  <div *ngIf="isLoadingDetails" class="loading-feedback center-loader">
    <p-progressSpinner strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
  </div>
  <div *ngIf="!isLoadingDetails">
    <div class="test-details-container">
      <div *ngFor="let section of getGroupedSections(testDetailsData); let last = last">
        <div class="test-section">
          <div class="test-section-title">{{ section.name }}</div>
          <hr class="section-underline">
        </div>
        <div *ngFor="let item of section.fields">
          <div class="test-row">
            <div class="test-field label">{{ item.label }}</div>
            <div class="test-field separator">:</div>
            <div class="test-field value" [innerHTML]="item.value ? item.value : '-'"></div>
          </div>
        </div>
        <div *ngIf="!last" class="horizontal-line-wrapper">
          <hr class="section-divider" />
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-toast></p-toast>